import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { UserManagementContent } from '@/pageContents/userManagement/UserManagementContent';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';

const UserManagementPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Benutzerverwaltung | Starjack Backoffice</Helmet>

            <UserManagementContent />
        </>
    );
};

UserManagementPage.isProtected = true;
UserManagementPage.permissions = [Permission.DATA_MANAGEMENT_NAV];
UserManagementPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default UserManagementPage;
